import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutTopShipperReport } from "./autogen/AutogenLayoutTopShipperReport";

export class TopShipperReport extends AutogenLayoutTopShipperReport {
    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
    }

    switchCompareOnChange() {
        if(this.switchCompareBetweenPeriods.checked) {
            this.textboxPeriodTwo.enabled = true
            this.textboxPeriodTwo.dateDefault = this.textboxPeriodTwo.dateDefault
        }
        else {
            this.textboxPeriodTwo.enabled = false
            this.textboxPeriodTwo.clear()
        }
    }

    textboxCategoriesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.location = "Y"
    }
}
